export const dialogConfirmationButtonClassName = "confirmation";
export const dialogCancelButtonClassName = "btn-outline-primary";